import { render } from "./ProjectAdminAutocomplete.vue?vue&type=template&id=a7e7f0da&scoped=true"
import script from "./ProjectAdminAutocomplete.vue?vue&type=script&lang=js"
export * from "./ProjectAdminAutocomplete.vue?vue&type=script&lang=js"

import "./ProjectAdminAutocomplete.vue?vue&type=style&index=0&id=a7e7f0da&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7e7f0da"]])

export default __exports__